export enum FILTER_PARAM_NAMES {
  accountNumber = 'account_number'
}

export const EXPORTED_STATEMENTS_TABLE_TEST_ID = 'exported-statements-table';

// Exported Payouts
export const EXPORTED_PAYOUTS_TABLE_TEST_ID = 'exported-payouts-table';
export const EXPORTED_PAYOUTS_ACCOUNTS_FILTER_TEST_ID =
  'exported-payouts-accounts-filters';
export const EXPORTED_PAYOUTS_MODAL_TEST_ID = 'exported-payouts-modal';

// Exported Pay-ins
export const EXPORTED_PAYINS_HEADER_TEST_ID = 'exports_payins_header';
export const EXPORTED_PAYINS_TABLE_TEST_ID = 'exports_payins_table';
export const EXPORTED_PAYINS_ACCOUNTS_FILTER_TEST_ID =
  'exports_payins_account-select';
export const EXPORTED_PAYINS_MODAL_TEST_ID = 'exports_payins_download-modal';
export const DOWNLOAD_PAYINS_CSV_BUTTON_TEST_ID = 'exports_payins_download-btn';

export const DOWNLOAD_CSV_BUTTON_TEST_ID = 'export-csv-download-button';

export const EXPORTED_STATEMENT_MODAL_TEST_ID = 'exported-statement-modal';
